<template>
  <v-footer color="transparent" class="mt-5 pt-5">
    <v-layout justify-center row wrap>
        <v-flex text-xs-center xs12 class="pt-0">
          <div>
            <small class="d-block">&copy;{{ year }} - HUIREP platform is developed by Christian Aid with support from Start Network</small>
          </div>
        </v-flex>
      </v-layout>
  </v-footer>
</template>

<script>
export default {
  name: 'MainFooter',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.logo {
  width: 100%;
  max-width: 80px;
}
</style>
